export type SubNavigationLink = {
  href: string;
  label: string;
};

export type NavigationLink = {
  href: string;
  label: string;
  mobileName: string;
  underlineColor?: string;
  className?: string;
  submenu?: SubNavigationLink[];
};

const navigationLinks: NavigationLink[] = [
  {
    href: '/candidates',
    label: 'KANDIDATEN',
    mobileName: 'Kandidaten',
    submenu: [
        {
          href: '/candidates',
          label: 'Übersicht'
        },
        {
          href: '/candidates/aktive-jobsuche',
          label: 'Aktive Jobsuche'
        },
        {
          href: '/candidates/passive-jobsuche',
          label: 'Passive Jobsuche'
        }
      ]
    },
  {
    href: '/companies',
    label: 'UNTERNEHMEN',
    mobileName: 'Unternehmen',
    submenu: [
      {
        href: '/companies',
        label: 'Übersicht'
      },
      {
        href: '/companies/unternehmensfuehrung',
        label: 'Unternehmensführung'
      },
      {
        href: '/companies/hr-leitung',
        label: 'HR-Leitung'
      },
      {
        href: '/companies/it-verantwortliche',
        label: 'IT-Verantwortliche'
      }
    ]
  },
  {
    href: '/services',
    label: 'SERVICES',
    mobileName: 'Services',
    submenu: [
      {
        href: '/services',
        label: 'Übersicht'
      },
      {
        href: '/services/bigfive',
        label: 'Big Five Persönlichkeitstest'
      },
      {
        href: '/services/cost-per-hire',
        label: 'Cost-per-Hire Rechner'
      }
    ]
  },
  {
    href: '/jobs',
    label: 'JOBS',
    mobileName: 'Jobs'
  },
  {
    href: '/blog',
    label: 'BLOG',
    mobileName: 'Blog'
  },
  {
    href: '/about-us',
    label: 'ÜBER UNS',
    mobileName: 'About'
  },
  {
    href: '/contact',
    label: 'GET EARLY ACCESS',
    mobileName: 'Get Early Access',
    underlineColor: 'bg-true-blue',
    className: 'font-bold'
  }
];

export { navigationLinks }; 